<template>
    <div
        class="container-fluid w-100 h-100"
        style="overflow-x: hidden"
    >
        <navbar
            :title="$t('vehicle_allocation.title')"
            class="mb-1"
        />
        <div class="col-sm-12 nopads">
            <vehicle-allocation-search @search="fetchVehicleAllocationReports" />
            <div
                v-if="results.length > 0"
                class="button-container"
            >
                <button
                    class="btn btn-outline-primary form-button dont-print"
                    @click="showCharts = !showCharts"
                >
                    {{ showCharts ? $t('daily_summary.hide_graphs') : $t('daily_summary.show_graphs') }}
                </button>
            </div>
            <vehicle-allocation-charts
                v-if="results.length > 0 && showCharts"
                ref="charts"
                class="my-2"
                :results="results"
            />
            <vehicle-allocation-list
                :items="results"
                :params="lastSearchedParams"
            />
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </div>
</template>

<script>
import VehicleAllocationList from './VehicleAllocationList'
import VehicleAllocationSearch from './VehicleAllocationSearch'
import VehicleAllocationCharts from './VehicleAllocationCharts'
import {restApi} from '../../mixins/RestApiMixin'
import {vehicleHelper} from '../../mixins/VehicleMixin'
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";

export default {
    name: 'VehicleAllocation',
    components: {Navbar, VehicleAllocationList, VehicleAllocationSearch, VehicleAllocationCharts},
    mixins: [restApi, vehicleHelper],
    props: {
        isObserver: Boolean
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            results: [],
            defect: null,
            showCharts: true,
            loading: false,
            vehicles: [],
            lastSearchedParams: null
        }
    },
    methods: {
        fetchVehicleAllocationReports: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.vehicleAllocationSummaryUrl, this.lastSearchedParams, this.handleResponse, this.handleError)
        },

        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },

        handleError: function () {
            this.loading = false
            this.showAlert(this.$t('trip_list.err_general'))
        },

    }
}
</script>

<style scoped>

</style>
